export enum Errors {
    FILE_COUNT_LIMIT_EXCEEDED,
    FILE_SIZE_LIMIT_EXCEEDED,
    INVALID_FILE_SIZE_FOUND,
    INVALID_FILE_TYPE_FOUND,
}

export class FileValidator {
    private static readonly MIN_FILE_SIZE = 1;
    private static readonly MAX_SIZE_OF_ALL_FILES = 15000000;
    private static readonly MAX_FILE_COUNT = 5;

    private static acceptedFileTypes: string[] = ['image/png', 'image/jpeg', 'image/jpg'];

    public static isValid(file: File) {
        return this.isFileSizeValid(file) && this.isFileTypeValid(file);
    }

    public static getOverallErrors(files: File[]): Set<Errors> {
        let fileSizeCounter = 0;
        const errors = new Set<Errors>();

        files.forEach((file: File) => {
            fileSizeCounter += file.size;

            if (!this.isFileTypeValid(file)) {
                errors.add(Errors.INVALID_FILE_TYPE_FOUND);
            }

            if (!this.isFileSizeValid(file)) {
                errors.add(Errors.INVALID_FILE_SIZE_FOUND);
            }
        });

        if (files.length > FileValidator.MAX_FILE_COUNT) {
            errors.add(Errors.FILE_COUNT_LIMIT_EXCEEDED);
        }

        if (fileSizeCounter > FileValidator.MAX_SIZE_OF_ALL_FILES) {
            errors.add(Errors.FILE_SIZE_LIMIT_EXCEEDED);
        }

        return errors;
    }

    private static isFileSizeValid(file: File) {
        return file.size >= this.MIN_FILE_SIZE;
    }

    private static isFileTypeValid(file: File) {
        return this.acceptedFileTypes.includes(file.type);
    }
}
